import React,{useState} from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { RxCross2 } from "react-icons/rx";
import Button from "../components/core/HomePage/Button";
import { respondAnEnquiry } from "../services/operations/CourseApi";
import { useLocation } from "react-router-dom";
export default function QueryRespondModal({ setModalData, responseData }) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [responded,setResponded]= useState(false);
  const { user } = useSelector((state) => state.profile);
  const { token } = useSelector((state) => state.auth);
  async function SubmitHandler(data) {
    setValue("id",responseData.id);
    console.log(responseData)
   const response = await respondAnEnquiry({
    answer:data.answer,
    queryId:responseData.id
   },token);
   setModalData(null)
   window.location.reload();
  }
  return (
    <div className="fixed inset-0 z-[1000] !mt-0 grid h-screen w-screen place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm">
      <div className="my-10 w-11/12 max-w-[700px] rounded-lg border border-richblack-400 bg-richblack-800">
        {/* Modal Header */}
        <div className="flex items-center justify-between rounded-t-lg bg-richblack-700 p-5">
          <p className="text-xl font-semibold text-richblack-5">Answer the Query</p>
          <button onClick={() => setModalData(null)}>
            <RxCross2 className="text-2xl text-richblack-5" />
          </button>
        </div>
        {/* Modal Body */}
        <div className="p-6">
          <div className="flex items-center capitalize justify-center gap-x-4">
            <img
              src={user?.image}
              alt={user?.firstName + "profile"}
              className="aspect-square w-[50px] rounded-full object-cover"
            />
            <div className="">
              <p className="font-semibold text-richblack-5">
                {user?.firstName} {user?.lastName}
              </p>
              <p className="text-sm text-richblack-5">Posting Publically</p>
            </div>
          </div>
          <form
            onSubmit={handleSubmit(SubmitHandler)}
            className="mt-6 flex flex-col items-center"
          >
            <div className="flex w-11/12 flex-col space-y-2">
              <label className="text-sm text-richblack-5" htmlFor="Answer">
                Add Your Answer <sup className="text-pink-200">*</sup>
              </label>
              <textarea
                id="Answer"
                placeholder="Type Your Answer here "
                {...register("answer", { required: true })}
                className="form-style resize-x-none min-h-[130px] w-full"
              />
              {errors.answer && (
                <span className="ml-2 text-xs tracking-wide text-pink-200">
                  Please Add valid answer
                </span>
              )}
            </div>
            <div className="mt-6 flex w-11/12 justify-end gap-x-2">
              <button
                onClick={() => setModalData(false)}
                className={`flex cursor-pointer items-center gap-x-2 rounded-md bg-richblack-300 py-[8px] px-[20px] font-semibold text-richblack-900`}
              >
                Cancel
              </button>

              <button type="submit" className="text-center capitalize text-[13px] px-6 py-3  font-bold rounded-lg bg-yellow-50 text-black">save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
